import * as React from 'react';
import classNames from 'classnames';
import { isNil } from 'lodash';

import { sanitizeGenericHtml } from 'utils/sanitize';

import './field-description-card.scss';

type Props = {
  visible: boolean,
  top: number,
  width?: number,
  text?: string,
  children?: React.ReactNode
};

class FieldDescriptionCard extends React.PureComponent<Props> {
  static defaultProps = {
    top: 0
  };

  render(): React.ReactNode {
    const {
      text,
      visible,
      top,
      children,
      width
    } = this.props;
    const maxWidth = !isNil(width) ? width : undefined;

    if (!visible) {
      return null;
    }

    return (
      <div
        className="field-description-card"
        style={{ top, maxWidth }}
      >
        {
          text &&
            <span
              className="field-description-card__text"
              dangerouslySetInnerHTML={{ __html: sanitizeGenericHtml(text) }}
            />
        }
        {
          React.Children.map(children, (child) => {
            if (!React.isValidElement(child)) {
              return child;
            }

            if (child.type === 'img') {
              const currentClasses = classNames({
                [child.props.className]: !isNil(child.props.className),
                'field-description-card__image': true
              });

              return React.cloneElement(child, { className: currentClasses });
            }

            return child;
          })
        }
      </div>
    );
  }
}

export default FieldDescriptionCard;
